import logoBtImageUrl from './img/logo-bt.png'
import logoShieldBtImageUrl from './img/logo-shield-bt.png'
import logoGreenImageUrl from './img/logo-green.svg'
import modelImageUrl from './img/model.svg'
import modelMImageUrl from './img/model-m.svg'
import arrowImageUrl from './img/t-arrow.svg'
// import memberAlexImageUrl from './img/member-alex.jpg'
// import memberJackImageUrl from './img/member-jack.jpg'
// import memberMartinImageUrl from './img/member-martin.jpg'
// import memberSeanImageUrl from './img/member-sean.jpg'

// partners
import partnerAlienSwapImageUrl from './img/partner/AlienSwap.png'
import partnerDaoMakerImageUrl from './img/partner/DaoMaker.svg'
import partnerGeekImageUrl from './img/partner/Geek.svg'
import partnerMetaOasisImageUrl from './img/partner/MetaOasis.png'
import partnerMirrorWorldImageUrl from './img/partner/MirrorWorld.png'
import partnerNFTBImageUrl from './img/partner/NFTB.svg'
import partnerSaasGoImageUrl from './img/partner/SaaSGo.png'
import partnerSalusImageUrl from './img/partner/Salus.svg'
import partnerStarryNiftImageUrl from './img/partner/StarryNift.png'
import partnerWeb3GamesImageUrl from './img/partner/Web3Games.png'
import partnerZKpassImageUrl from './img/partner/ZKPass.png'

// hover
import partnerHoverAlienSwapImageUrl from './img/partner-hover/AlienSwap-hover.png'
import partnerHoverDaoMakerImageUrl from './img/partner-hover/DaoMaker-hover.svg'
// import partnerHoverGeekImageUrl from './img/partner-hover/Geek-hover.svg'
import partnerHoverMetaOasisImageUrl from './img/partner-hover/MetaOasis-hover.png'
import partnerHoverMirrorWorldImageUrl from './img/partner-hover/MirrorWorld-hover.png'
import partnerHoverNFTBImageUrl from './img/partner-hover/NFTB-hover.svg'
import partnerHoverSaasGoImageUrl from './img/partner-hover/SaaSGo-hover.png'
import partnerHoverSalusImageUrl from './img/partner-hover/Salus-hover.svg'
import partnerHoverStarryNiftImageUrl from './img/partner-hover/StarryNift-hover.png'
import partnerHoverWeb3GamesImageUrl from './img/partner-hover/Web3Games-hover.png'
import partnerHoverZKpassImageUrl from './img/partner-hover/ZKPass-hover.png'

const imageUrls = [
  logoBtImageUrl,
  logoShieldBtImageUrl,
  logoGreenImageUrl,
  modelImageUrl,
  modelMImageUrl,
  arrowImageUrl,
  partnerAlienSwapImageUrl,
  partnerDaoMakerImageUrl,
  partnerGeekImageUrl,
  partnerMetaOasisImageUrl,
  partnerMirrorWorldImageUrl,
  partnerNFTBImageUrl,
  partnerSaasGoImageUrl,
  partnerSalusImageUrl,
  partnerStarryNiftImageUrl,
  partnerWeb3GamesImageUrl,
  partnerZKpassImageUrl,

  partnerHoverAlienSwapImageUrl,
  partnerHoverDaoMakerImageUrl,
  // partnerHoverGeekImageUrl,
  partnerHoverMetaOasisImageUrl,
  partnerHoverMirrorWorldImageUrl,
  partnerHoverNFTBImageUrl,
  partnerHoverSaasGoImageUrl,
  partnerHoverSalusImageUrl,
  partnerHoverStarryNiftImageUrl,
  partnerHoverWeb3GamesImageUrl,
  partnerHoverZKpassImageUrl,
]

const partnerImageUrls = {
  investor: [
    partnerGeekImageUrl,
  ],
  partner: {
    partnerSalusImageUrl,
    partnerAlienSwapImageUrl,
    partnerDaoMakerImageUrl,
    partnerMetaOasisImageUrl,
    partnerMirrorWorldImageUrl,
    partnerNFTBImageUrl,
    partnerSaasGoImageUrl,
    partnerStarryNiftImageUrl,
    partnerWeb3GamesImageUrl,
    partnerZKpassImageUrl,
  },
  partnerHover: {
    partnerHoverAlienSwapImageUrl,
    partnerHoverDaoMakerImageUrl,
    // partnerHoverGeekImageUrl,
    partnerHoverMetaOasisImageUrl,
    partnerHoverMirrorWorldImageUrl,
    partnerHoverNFTBImageUrl,
    partnerHoverSaasGoImageUrl,
    partnerHoverSalusImageUrl,
    partnerHoverStarryNiftImageUrl,
    partnerHoverWeb3GamesImageUrl,
    partnerHoverZKpassImageUrl,
  },
}

export {
  imageUrls,
  partnerImageUrls,

  logoBtImageUrl,
  logoShieldBtImageUrl,
  logoGreenImageUrl,
  modelImageUrl,
  modelMImageUrl,
  arrowImageUrl,

  partnerAlienSwapImageUrl,
  partnerDaoMakerImageUrl,
  partnerGeekImageUrl,
  partnerMetaOasisImageUrl,
  partnerMirrorWorldImageUrl,
  partnerNFTBImageUrl,
  partnerSaasGoImageUrl,
  partnerSalusImageUrl,
  partnerStarryNiftImageUrl,
  partnerWeb3GamesImageUrl,
  partnerZKpassImageUrl,
}